import { createSlice } from "@reduxjs/toolkit";
import { getClientLicenseList } from "./thunk";

const getClientLicenseListSlice = createSlice({
    name: "getClientLicenseList",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getClientLicenseList.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getClientLicenseList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getClientLicenseList.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

    }
});

export default getClientLicenseListSlice.reducer;